/**
 * The Server Configs Values retrieved from the Server
 */
import { SET_SERVER_CONFIG_VALUES } from "../actionTypes.js";
import { replaceReducer } from "./common/index.js";
export default replaceReducer(SET_SERVER_CONFIG_VALUES, null);
//# sourceMappingURL=serverConfigValues.js.map